export default __webpack_public_path__ + "static/media/Talent_Quest_TradeSecrets.bf803033.png";